import React, { useState } from 'react';

export default function ServiceSummarySelect({ label, icon, value, options, placeholder, canEdit, canClear = true, onSave }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const selected = options.find(option => String(option.value) === String(value));

  const startEditing = () => {
    setDraft(value == null ? '' : String(value));
    setError('');
    setEditing(true);
  };

  const save = async () => {
    setSaving(true);
    setError('');
    try {
      await onSave(draft === '' ? null : Number(draft));
      setEditing(false);
    } catch (failure) {
      const validationErrors = failure.response?.data?.errors;
      setError(failure.response?.data?.message
        || (validationErrors && Object.values(validationErrors).flat().join(' '))
        || failure.message || 'Değişiklik kaydedilemedi. Tekrar deneyin.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={`sd-summary-item sd-summary-editable${editing ? ' is-editing' : ''}`} aria-busy={saving}>
      <i className={`fa ${icon}`} aria-hidden="true" />
      <span>
        <small>{label}</small>
        {editing ? (
          <>
            <div className="sd-summary-select-controls">
              <select className="form-control" aria-label={label} value={draft}
                disabled={saving || !canEdit} autoFocus
                onChange={event => setDraft(event.target.value)}
                onKeyDown={event => {
                  if (event.key === 'Escape' && !saving) setEditing(false);
                }}>
                <option value="" disabled={!canClear}>{placeholder}</option>
                {options.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
              </select>
              <div className="sd-summary-select-actions">
                <button type="button" className="save" disabled={saving || !canEdit || (!canClear && draft === '')} onClick={save}
                  title="Kaydet" aria-label={`${label} kaydet`}>
                  <i className={`fa ${saving ? 'fa-circle-o-notch fa-spin' : 'fa-check'}`} aria-hidden="true" />
                </button>
                <button type="button" disabled={saving} onClick={() => setEditing(false)}
                  title="Vazgeç" aria-label={`${label} iptal`}><i className="fa fa-times" aria-hidden="true" /></button>
              </div>
            </div>
            {error && <span className="sd-summary-select-error" role="alert">{error}</span>}
          </>
        ) : <strong title={selected?.label || placeholder}>{selected?.label || placeholder}</strong>}
      </span>
      {!editing && canEdit && (
        <button type="button" title={`${label} düzenle`} aria-label={`${label} düzenle`} onClick={startEditing}>
          <i className="icon-pencil" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
